import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import MetaReadOnlyView from 'Components/UI/Meta/MetaReadOnlyView';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  accountInfoParent: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  activityRow: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  rowStatus: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.palette.facet.accentGreen2,
    minWidth: '100px',
    textAlign: 'center',
  },
  rowStatusText: {
    padding: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
  rowStatusDate: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
  },
  rowStatusComment: {
    marginLeft: theme.spacing(2),
  },
  rowStatusCommentText: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
    maxWidth: '160px',
  },
  rowStatusUser: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.darkGray,
  },
});

const View = ({ classes, profiles }) => {
  if (profiles.length === 0) {
    return null;
  }
  return (
    <Box className={classes.root} debugColor="chartreuse">
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        Profiles
      </Typography>
      <Box debugColor="crimson">
        {profiles.map(profile => (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id={profile.id()}
            >
              <Typography className={classes.heading}>{`${profile.attr('name')} - ${profile.attr('certainty')}`}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <MetaReadOnlyView resource={profile} />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  profiles: PropTypes.array,
};
View.defaultProps = {
  profiles: [],
};

export default withStyles(styles)(View);
